// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch,
.switch-label {
    position: relative;
    display: inline-block;
    width: 85px;
    height: 26px;
}

.switch-label input {
    display: none;
}

.switch-label[disabled] {
    opacity: 0.5;
}

.switch-label .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--outline);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 34px;
}

.switch-label .slider:hover {
    background-color: var(--outline-variant);
}

.switch-label .slider:before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    left: 4px;
    bottom: 3px;
    background-color: var(--background);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
}

.switch-label .slider[disabled] {
    cursor: not-allowed;
}

.switch-label input:checked + .slider {
    background-color: var(--primary);
}

.switch-label input:checked + .slider:hover {
    background-color: var(--primary-container);
}

.switch-label input:checked + .slider:before {
    /* create a var to save the translateX */
    --translateX: 58px;
    -webkit-transform: translateX(var(--translateX));
    -ms-transform: translateX(var(--translateX));
    transform: translateX(var(--translateX));
}

.switch-text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: white;
    z-index: 1;
    pointer-events: none;
    width: 55px;
    text-align: center;
    transition:
        transform 0.4s,
        color 0.4s;
}

.switch-on {
    display: block;
}

.switch-off {
    display: none;
}

[data-switch-text-right] {
    right: 5px;
}

[data-switch-text-left] {
    left: 5px;
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/common-switch.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,mCAAmC;IACnC,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,gDAAgD;IAChD,4CAA4C;IAC5C,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,WAAW;IACX,kBAAkB;IAClB;;kBAEc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb","sourcesContent":[".switch,\n.switch-label {\n    position: relative;\n    display: inline-block;\n    width: 85px;\n    height: 26px;\n}\n\n.switch-label input {\n    display: none;\n}\n\n.switch-label[disabled] {\n    opacity: 0.5;\n}\n\n.switch-label .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--outline);\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    border-radius: 34px;\n}\n\n.switch-label .slider:hover {\n    background-color: var(--outline-variant);\n}\n\n.switch-label .slider:before {\n    position: absolute;\n    content: '';\n    height: 20px;\n    width: 20px;\n    left: 4px;\n    bottom: 3px;\n    background-color: var(--background);\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    border-radius: 50%;\n}\n\n.switch-label .slider[disabled] {\n    cursor: not-allowed;\n}\n\n.switch-label input:checked + .slider {\n    background-color: var(--primary);\n}\n\n.switch-label input:checked + .slider:hover {\n    background-color: var(--primary-container);\n}\n\n.switch-label input:checked + .slider:before {\n    /* create a var to save the translateX */\n    --translateX: 58px;\n    -webkit-transform: translateX(var(--translateX));\n    -ms-transform: translateX(var(--translateX));\n    transform: translateX(var(--translateX));\n}\n\n.switch-text {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    color: white;\n    z-index: 1;\n    pointer-events: none;\n    width: 55px;\n    text-align: center;\n    transition:\n        transform 0.4s,\n        color 0.4s;\n}\n\n.switch-on {\n    display: block;\n}\n\n.switch-off {\n    display: none;\n}\n\n[data-switch-text-right] {\n    right: 5px;\n}\n\n[data-switch-text-left] {\n    left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
